{
  "application": {
    "environment": "production"
  },
  "brand": "jobalto",
  "caPub": "",
  "gaApiKey": "",
  "backendUrl": "https://api.jobalto.com",
  "_backendUrl": "http://localhost:8000",
  "sentryDsn": "",
  "sentrySendPii": false,
  "sentryTracesSampleRate": 0.05,
  "amplitudeApiKey": "",
  "imageSource": "https://imagedelivery.net/8CA2tdaqNe_KDNIRc5st7Q",
  "firebaseConfig": {
    "apiKey": "AIzaSyAbl-x6fLMeFi4ZFgRjuXOJkwf17zuQUso",
    "authDomain": "job-atlas-auth.firebaseapp.com",
    "projectId": "job-atlas-auth",
    "storageBucket": "job-atlas-auth.firebasestorage.app",
    "messagingSenderId": "303497845514",
    "appId": "1:303497845514:web:c3a57272185c38c0aa38f3",
    "measurementId": "G-34HR0F88J2"
  }
}
